import PageHeading from '../components/PageHeading';
import { FileText } from 'lucide-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * 服务条款页面
 */
function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-canvas">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        {/* 返回按钮 */}
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-muted hover:text-ink mb-6 transition-all duration-300"
        >
          <ArrowLeft size={20} />
          返回
        </button>

        {/* 标题 */}
        <PageHeading Icon={FileText} eyebrow="LEGAL · 服务条款" title="服务条款" description="生效日期：2026年3月23日" />

        {/* 内容 */}
        <div className="prose prose-gray max-w-none">
          <p className="text-muted mb-6">
            欢迎使用 AI 大师兄（GetPro，以下简称"本服务"）。在使用本网站 getpro.plus 及其提供的服务前，请您仔细阅读以下条款。使用本服务即表示您同意接受这些条款的约束。
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">1. 服务说明</h2>
            <div className="space-y-3 text-muted">
              <p>
                <strong className="text-ink">独立服务商：</strong>AI 大师兄（GetPro）是一家独立的第三方服务提供商，致力于为用户提供便捷的 ChatGPT Plus/Pro 账户充值、成品账号及网页共享服务。
              </p>
              <p>
                <strong className="text-ink">非官方声明：</strong>本服务与 OpenAI (ChatGPT) 或其他 AI 模型提供商无官方隶属关系。所有相关商标归原持有人所有。
              </p>
              <p>
                <strong className="text-ink">服务性质：</strong>我们提供"代充值服务"、"成品账号交付"及"网页共享服务"，不对 AI 模型本身的生成内容、准确性或服务稳定性负责。
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">2. 账户与安全</h2>
            <div className="space-y-3 text-muted">
              <p>您有责任妥善保管我们交付给您的账户信息（如账号密码、共享链接）。</p>
              <p>因您个人原因（如转借他人、泄露密码、IP 异常）导致的账户丢失或被封禁，本平台不承担责任。</p>
              <p>严禁利用本平台提供的账户进行任何违反当地法律法规的活动。</p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">3. 支付与退款政策</h2>
            <div className="space-y-3 text-muted">
              <p>
                <strong className="text-ink">虚拟商品特殊性：</strong>鉴于虚拟商品（如充值服务、成品账号、共享号）的特殊性，一旦发货（即账号信息发送至您的邮箱），原则上不接受无理由退款。
              </p>
              <p>
                <strong className="text-ink">例外情况：</strong>
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>若交付的账号在首次使用前已被验证为无效或不可用，我们承诺在核实后提供 100% 全额退款或补发。</li>
                <li>请在购买后 24小时内 激活或核验您的商品，逾期可能影响售后处理。</li>
              </ul>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">4. 服务时效</h2>
            <div className="space-y-3 text-muted">
              <p>
                <strong className="text-ink">交付时间：</strong>正常情况下，我们承诺在 5-10分钟内 完成充值或账号交付。
              </p>
              <p>
                <strong className="text-ink">延迟说明：</strong>如遇高峰期或特殊情况，交付时间可能延长，我们会及时通知您。
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">5. 免责声明</h2>
            <div className="space-y-3 text-muted">
              <p>
                <strong className="text-ink">上游风险：</strong>若因 OpenAI 官方政策调整、大规模风控导致的服务中断或账号封禁，属于不可抗力。我们将尽力协助用户解决，但不承担连带赔偿责任。
              </p>
              <p>
                <strong className="text-ink">服务变更：</strong>我们保留随时修改、暂停或终止部分服务的权利，但会尽可能提前通知用户。
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">6. 联系方式</h2>
            <div className="space-y-3 text-muted">
              <p>如对本条款有任何疑问，或需要售后支持，请通过以下方式联系我们：</p>
              <p>
                <strong className="text-ink">网站：</strong>getpro.plus<br />
                <strong className="text-ink">电子邮件：</strong>ricky@savvyai.plus
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-ink mb-4">7. 条款变更</h2>
            <div className="space-y-3 text-muted">
              <p>我们保留随时修改本服务条款的权利。修改后的条款将在本页面发布，重大变更我们将通过显著方式通知您。继续使用本服务即表示您接受修改后的条款。</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;
